import React from "react";

interface FormStepProps {
  stepNumber: number;
  isActive: boolean;
  children: React.ReactNode;
  className?: string;
}

export function FormStep({
  stepNumber,
  isActive,
  children,
  className = "",
}: FormStepProps) {
  if (!isActive) return null;

  return (
    <div className={`relative ${className}`}>
      {children}
    </div>
  );
}